import { ReactElement } from 'react';
import InputCheckbox from '~/components/input/InputCheckbox';
import BreBoostConfig from '~/tenants/bre/performable/boost/BreBoostConfig';
import { BreBoostFields } from '~/tenants/bre/performable/boost/BreBoostFields';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TenantPackageAddOnTemplate } from '~/tenants/common/package';
import PerformableGroupForm, { usePerformableGroup } from '~/components/performable/PerformableGroupForm';

export default function BreBoostAddOn({ persona }: { persona: PersonaType }): ReactElement {
  const group = usePerformableGroup();
  const added = group.hasPerformable(BreBoostConfig);

  return (
    <TenantPackageAddOnTemplate
      htmlFor="boost"
      title="Social Media Boosting"
      description={added ? undefined : BreBoostConfig.short}
      image="tenant/bre/boost.jpg"
      persona={persona}
      enable={
        <InputCheckbox
          id="boost"
          checked={added}
          onChange={() => {
            if (added) {
              group.removePerformable(BreBoostConfig);
            } else {
              group.addPerformable(BreBoostConfig);
            }
          }}
        />
      }
    >
      {added && (
        <PerformableGroupForm performable={BreBoostConfig}>
          <BreBoostFields />
        </PerformableGroupForm>
      )}
    </TenantPackageAddOnTemplate>
  );
}
